import { render } from "./Thanks404.vue?vue&type=template&id=269fc135&lang=pug"
import script from "./Thanks404.vue?vue&type=script&lang=js"
export * from "./Thanks404.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__